export default {
  pages: {
    createReject: {
      title: 'Yangi qaytarish',
    },
  },
};
